module.exports = __webpack_public_path__ + "media/notif7.ac15e7e7.wav";